<template>
  <div class="row align-items-center border-bottom border-bottom-1 border-gray-200 py-10">
    <Select2
        container-class="form-group col-12 col-md-5 mb-7"
        :multiple="false"
        :show-search="true"
        :selectClass="'form-select form-control-sm form-select-solid'"
        :name="`payslip-tax-`+id"
        :label="$t('payslip.label.title')"
        labelClass="form-label fs-6 text-black"
        :placeholder-text="$t('payslip.label.title')"
        :parent-id="parentId && '#'+parentId"
        v-model="taxData.id"
        :IsInputGroup="$can(abilities.CREATE_PAYROLL_TAX)"
        icon="bi bi-plus"
        :clickAddon="openTaxModal">
      <option v-for="tax in taxes" :value="tax.id" :key="tax.id">
        {{ tax.title }}
      </option>
    </Select2>

    <InputAmount
        containerClass="col-12 col-md-5 mb-7"
        :label="$t('payslip.label.amount')"
        labelClass="form-label fs-6 text-black"
        :inputClass="'form-control form-control-solid'"
        :number="taxData.value"
        :iso="currency"
        :required="true"
        @keyup="handleEdited"
        @amount="(val) => taxData.value = val"/>

    <div class="col-2">
      <a class="btn btn-sm btn-icon btn-danger p-5" @click.prevent="deleteTaxRow(index)">
        <i class="bi bi-trash-fill fs-5"></i>
      </a>
    </div>
  </div>

  <NewTaxeModal :id="'tax-create-modal'+id" @reloadDatatable="reloadTaxes" :category="taxType" />
</template>

<script setup>

import Select2 from "@/components/Select2.vue";
import {computed, defineEmits, defineProps, onMounted, ref, watch} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import NewTaxeModal from "@/Modules/RH/views/Setting/taxes/components/NewTaxeModal.vue";
import {calculatePayslipItemValue} from "@/mixins/Helpers";
import abilities from "@/composables/abilities";
import InputAmount from "@/components/InputAmount.vue";

const store = useStore()
const emits = defineEmits(["deleteRow"])
const props = defineProps({
  parentId: String,
  baseSalary: "",
  taxType: "",
  tax: {
    type: Object,
    default: () => ({
      id: '',
      value: 0,
      edited: false,
    })
  },
  currency: String,
  index: Number,
  id: String,
})


const taxData = ref(props.tax)

const allTaxes = computed(() => store.getters['payrollTaxes/getPayrollTaxes'])
const taxes = computed(() =>  {
  if(!props.taxType) return allTaxes.value
  return allTaxes.value.filter(tax => tax?.category?.value === props.taxType)
})

const selectedTaxData = computed(() => {
  if(!taxData.value.id) return null
  return taxes.value.find(al => al.id === taxData.value.id)
})



watch(() => [props.baseSalary, taxData.value.id], () => {
  handleChange()
})

const calcSalaryWithTax = (salary, tax) => {
  if (!salary) return 0
  if(!tax) return 0
  const taxData = tax?.data.map?.(al => ({
    range_max: parseFloat(al.range_max),
    range_min: parseFloat(al.range_min),
    type: al.type,
    value: parseFloat(al.value)
  }))
  return calculatePayslipItemValue(parseFloat(props.baseSalary), taxData)
}

const handleChange = () => {
  taxData.value.edited = false
  taxData.value.value = calcSalaryWithTax(props.baseSalary, selectedTaxData.value)
}

const handleEdited = () => {
  taxData.value.edited = true
}

const openTaxModal = () => {
  $('#tax-create-modal'+props.id).modal('toggle')
}

function deleteTaxRow(index) {
  emits('deleteRow', index)
}

function reloadTaxes() {
  store.dispatch('payrollTaxes/loadPayslipTaxes')
}

onMounted(() => {
  handleChange()
})

</script>

<style scoped>
</style>
